export const logChangesTableColumns = [
  { label: "Data e hora", value: "created_at", className: "w-32" },
  { label: "Objeto", value: "item_name_translated" },
  { label: "Alteração", value: "changes", className: "p-0" },
  { label: "Ações", value: "actions", className: "w-9" },
];
